export const AUTH_TOOLTIP_TIMEOUT = 10000
export const AUTH_TOOLTIP_COOKIE_VALUE = 'true'
export const AUTH_TOOLTIP_COOKIE_EXPIRY_DAYS = 1
export const TOAST_LOCAL_ANCHOR = '.userNavSignInBtn'
export const OO_ANCHOR = '.userIcon'
export const TOAST_LOCAL_IDENTIFIER = 'local'

export const getAuthTooltipCookieKey = (rxGuid?: string) =>
  `toast-sites-auth-tooltip-closed|${rxGuid}`

export const setAuthTooltipCookie = (
  rxGuid: string,
  setCookie: (key: string, value: string, options: any) => void
) => {
  if (!rxGuid) return
  setCookie(getAuthTooltipCookieKey(rxGuid), AUTH_TOOLTIP_COOKIE_VALUE, {
    expires: new Date(
      Date.now() + AUTH_TOOLTIP_COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000
    )
  })
}
